<template>
    <div>
        <div class="Controls" @click="choosePerson()" :class="{'Controls--disabled':itemData.disabled}">
            <span class="name">
                {{itemData.cnFieldCaption}}
                <span style="color:#D0021B" v-if="prop()">*</span>
            </span>
            <span>{{obj.text}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Controls',
    props: {
        itemData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        sysBoxValue: {
            type: Array,
            default: function () {
                return []
            }
        },
        type: {
            type: String,
            default: 'otNew'
        }
    },
    data() {
        return {
            show: false,
            actions: [],
            text: '',
            obj: {
                text: '',
                value: ''
            }
        }
    },
    created() {
    },
    mounted() {
        this.unit()
    },
    methods: {
        updates(value) {
            if (value == '') {
                return false
            }
            this.obj.value = value
            this.returnItem(value)
        },
        async choosePerson() {
            if (this.itemData.disabled) return
            try {
                this.obj = await this.Global.utils.chosen.open(this.actions)
            } catch (error) {

            }
        },
        returnItem(value) {
            this.sysBoxValue.forEach(element => {
                if (element.dictCode == this.itemData.dictCode) {
                    element.dictItems.forEach(item => {
                        if (item.dictItemCode == value) {
                            this.obj.text = item.itemName
                        }
                    })
                }
            })
        },
        submit(isNoCheckNull = false) {
            let data = {}
            if (this.prop() && !isNoCheckNull) {
                if (this.obj.value == '') {
                    this.$toast.fail(this.itemData.cnFieldCaption + this.$t('mx_mobile.Client.1585301350281')) // 不能为空
                    return false
                }
            }
            if (this.obj.value && this.obj.value != '' && this.obj.value != 0) {
                data[this.itemData.fieldName] = this.obj.value + ''
            } else {
                data[this.itemData.fieldName] = 0
            }
            // alert(data[this.itemData.fieldName])
            return data
        },
        prop() {
            if (this.itemData.disabled) {
                return ''
            }
            if (this.itemData.isNotNull == 1) {
                return true
            } else {
                return false
            }
        },
        async unit() {
            this.actions = []
            let res = await this.axios.get(this.Global.config.apiBaseURL + this.Global.api.v2.custArea, { params: { type: 'list' } })
            if (res.data.code.toString() === this.Global.config.RES_OK) {
                res.data.data.forEach(element => {
                    if (element.inUse != '0') {
                        this.options.push({
                            text: element.areaName,
                            value: element.areaId,
                            areaItem: element.areaItem
                        })
                    }
                })
                if (this.type == 'otNew' && this.itemData.inDefaultValue != '') {
                    this.updates(this.itemData.inDefaultValue)
                }
            }
        }

    },
    watch: {
    },
    components: {
    }
}
</script>

<style lang="less" scoped>
.Controls {
    width: 100%;
    .min-height(45px);
    position: relative;
        .padding-left(100px);
    &:lang(en){
        .padding-left(130px);
    }
    .name {
        color: #909399;
        .font-size(14px);
        position: absolute;
        left: 0;
    }
    &--disabled {
        .name {
            color: #eaeaea;
        }
    }
}
</style>
